export const CmsSharedKeys = {
  CmsStore: {id: 'CmsStore', defaultValue: {}},
};
